"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuinationEffectHandler = exports.RuinationEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class RuinationEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Ruination;
        this.__typeName = "Ruination";
        this.name = "Ruination";
        this.harmful = true;
    }
}
exports.RuinationEffectArgs = RuinationEffectArgs;
let RuinationEffectHandler = class RuinationEffectHandler {
    apply(sequence, container, state) { }
    remove(sequence, container, state) { }
};
RuinationEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Ruination)
], RuinationEffectHandler);
exports.RuinationEffectHandler = RuinationEffectHandler;
